import { render, staticRenderFns } from "./compont.vue?vue&type=template&id=00bd5ebf&scoped=true&"
import script from "./compont.vue?vue&type=script&lang=js&"
export * from "./compont.vue?vue&type=script&lang=js&"
import style0 from "./compont.vue?vue&type=style&index=0&id=00bd5ebf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd5ebf",
  null
  
)

export default component.exports